import { render, staticRenderFns } from "./consult-add.vue?vue&type=template&id=543a7425&"
import script from "./consult-add.vue?vue&type=script&lang=js&"
export * from "./consult-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports